import styled from "styled-components/macro";

export const ListItemContent = styled.div`
  && {
    padding: 0 0.5em 1em 0.5em;
    text-align: left;
    width: 100%;
  }
`;

export const ListItemTitle = styled.div`
  && {
    font-family: Work Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 130%;
    padding-bottom: 0.25em;
  }
`;

export const ListItemText = styled.div`
  && {
    font-family: Work Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 14px;
    padding: 0.25em 0 0.25em 0;
  }
`;
